<script setup lang="ts">
import { BuildingOfficeIcon } from '@heroicons/vue/24/outline'
import { type Component, computed } from 'vue'

import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import { translationFunctionDefault } from '@/utilities/translations'

interface AvatarOrganizationProps {
  size: 'big' | 'huge' | 'medium' | 'small'
  fallbackIcon?: Component | undefined
  image?: string | undefined
}

const props = defineProps<AvatarOrganizationProps>()

const tfDefault = translationFunctionDefault()

const componentSize = {
  big: 'h-12 w-12',
  huge: 'h-28 w-28',
  medium: 'h-8 w-8',
  small: 'h-6 w-6',
}

const iconSize = {
  big: 'h-8 w-8',
  huge: 'h-16 w-16',
  medium: 'h-6 w-6',
  small: 'h-4 w-4',
}

const activeIcon = computed(() => props.fallbackIcon ?? BuildingOfficeIcon)
</script>

<template>
  <div
    class="flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-black-200"
    :class="[componentSize[props.size]]"
    :data-testid="TEST_IDS_CREATE.avatar.root"
  >
    <img
      v-if="!!props.image"
      :alt="tfDefault('relationships.profile')"
      class="h-full w-full object-cover"
      :data-testid="TEST_IDS_CREATE.avatar.image"
      :src="props.image"
    />
    <div v-else :data-testid="TEST_IDS_CREATE.avatar.icon">
      <component :is="activeIcon" class="text-black-300" :class="[iconSize[props.size]]" />
    </div>
  </div>
</template>
